import { Component, OnInit } from '@angular/core';
import {PublicService} from '../public.service';
import { FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  selector: 'app-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.scss']
})
export class SigninComponent implements OnInit {
  key = "deactive";
  loading = false;
  keyInv = "deactive";

  namesignin = new FormControl('', [
    Validators.required,
  ]);

  emailsignin = new FormControl('', [
    Validators.email,
  ]);

  constructor(public publicservice : PublicService, public router: Router) {
    console.log(publicservice.logedIn);

    // if(publicservice.logedIn == "true" && localStorage.getItem("goToSigninPage") == "false"){
    //   this.router.navigate(['home']);
    // }
   }

  ngOnInit(): void {
  }

  signin() {
    this.keyInv = "deactive";
    this.key = "deactive";
    if (this.namesignin.valid && this.emailsignin.valid) {
      this.loading = true;
      this.publicservice.signin().then((r) => {
        // console.log("ssssssssssss");
        this.loading = false;
        if( r.data == "email is not unique" ){

          this.key = "active";
        }
        if( r.message == "successful" ){
          localStorage.setItem("goToSigninPage", "false");
        this.router.navigate(['home']);
        }
        if( r.message == "not found code" ){
          this.keyInv = "active";
        }
      });
    }
  }

}
